<template>
  <div class="main-wrap">
    <action-bar title="消息中心" :left="true" @back="back"></action-bar>
    <ul class="nav">
      <li @click="goto('/home/user')">会员咨询</li>
      <li  @click="goto('/home/password')">修改密码</li>
      <li  class="active" @click="goto('/home/message')">消息中心</li>
      <li @click="goto('/home/account')">资金明细</li>
    </ul>

    <div class="content">
      <table width="100%">
        <tbody>
          <tr>
            <!--<th>标题</th>-->
            <th>内容</th>
            <!--<th>时间</th>-->
            <!--<th>状态</th>-->
          </tr>
          <tr v-for="p in message " :key="p.id" >
            <!--<td>{{p.title}}</td>-->
            <td>{{p.content}}</td>
            <!--<td>{{p.send_time | formatDate}}</td>-->
            <!--<td>{{p.is_read? "已读":"未读"}}</td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ActionBar from "@/components/action-bar";
import { getNotices } from "@/service/home";
import { async } from 'q';
export default {
  filters: {
      formatDate: function (value) {
        let date = new Date(parseInt(value+"000"));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
  },
  data() {
    return {
       message: []
    };
  },
  async created() {
     getNotices().then(res => {
      this.message = res.data;
     });
     //this.message =  await getNotices().data;
  },
  methods: {
       back(){
          this.$router.push('/home/main');
      },
       goto(url){
           this.$router.push(url);
      },
      detail(p){
          this.$router.push({path:'/home/msgDetail',query:{"id":p.id} })
      }
  },
  components: {
    ActionBar
  }
};
</script>

<style scoped lang="less">
.main-wrap {
  .nav {
    background-color: #ffffff;
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    font-size: 18px;
    li {
      width: 220px;
    }

    .active {
      border-bottom-color: #ba142b;
      border-bottom-width: 4px;
      color: #ba142b;
    }
  }
  .content {
    border-radius: 5px;
    margin: 20px 5px;
    height: auto;
    padding: 5px;
    background-color: #ffffff;
    font-size: 24px;
    table,
    td,
    th {
      height: 50px;
      border: 1px solid #cccccc;
      text-align: center;
      padding-top: 20px;
    }
    th {
      background-color: #eeeeee;
    }

    td .ipt-6 {
        width: 400px !important; 
        height: 50px;
        text-align: left !important;
        border: #999 1px solid;
        
    }

    .btn-bet {
        background: none repeat scroll 0 0 #e92f24;
        border: 1px solid #dc372c;
        border-radius: 4px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        height: 52px;
        text-align: center;
        width: 150px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/message/index.vue